// @ts-nocheck
import moment from 'moment';
import { newDateAndTimeFormat, newDateAndTimeFormatWithSeconds } from './constants';

const getColumns = columns => {
    return Object.values(columns).reduce(
        (res, column) => ({
            ...res,
            [column.key]: {
                export: column.export,
                label: column.export?.label || column.label,
                value: data => data[column.key],
            },
        }),
        {},
    );
};

const filterVisibleColumns = (columns, visibleColumns) => {
    if (!visibleColumns) return columns;

    const newColumns = {};
    const visibleColumnKeys = Object.keys(visibleColumns).filter(key => visibleColumns[key]);

    Object.keys(columns).forEach(columnKey => {
        if (visibleColumnKeys.includes(columnKey) || columns[columnKey].export?.exportOnly) {
            newColumns[columnKey] = columns[columnKey];
        }
    });

    return newColumns;
};

export const GAMING_ACTIVITY_FIRST_GROUP_COLUMNS = {
    name: {
        key: 'name',
        label: 'Group',
    },
    bets: {
        key: 'bets',
        label: '# of Bets',
    },
    sum: {
        key: 'sum',
        label: 'Turnover',
    },
    payout: {
        key: 'payout',
        label: 'Payout',
    },
    avgBets: {
        key: 'avgBets',
        label: 'Avg. Bet Amount',
    },
    ggr: {
        key: 'ggr',
        label: 'GGR',
    },
    margin: {
        key: 'margin',
        label: 'Margin (%)',
    },
    freeBetAmount: {
        key: 'freeBetAmount',
        label: 'Free Bet Amount',
    },
    freeBetPayout: {
        key: 'freeBetPayout',
        label: 'Free Bet Payout',
    },
};

export const TRANSACTION_COLUMNS = {
    toExcel: function ({ visibleColumns } = {}) {
        const columns = getColumns(this);

        return filterVisibleColumns(columns, visibleColumns);
    },
    // transactionId: {
    //     key: 'transactionId',
    //     label: 'Transaction ID',
    // },
    cashierCode: {
        key: 'cashierCode',
        label: 'Cashier Code',
    },
    cashierName: {
        key: 'cashierName',
        label: 'Cashier Name',
    },
    dateTime: {
        key: 'dateTime',
        label: 'Date/Time',
    },
    type: {
        key: 'type',
        label: 'Type',
    },
    amount: {
        key: 'amount',
        label: 'Amount',
    },
    accPeriodDebtOrCredit: {
        key: 'accPeriodDebtOrCredit',
        label: 'Acc. period debt/credit',
    },
    extraDebtCredit: {
        key: 'extraDebtCredit',
        label: 'Extra Debt/Credit',
    },
    initialCashierBalance: {
        key: 'initialCashierBalance',
        label: 'Initial Cashier Balance',
    },
    nextCashierBalance: {
        key: 'nextCashierBalance',
        label: 'Next Cashier Balance',
    },
};

export const BETS_INFORMATION_COLUMNS = {
    toExcel: function ({ visibleColumns } = {}) {
        const columns = getColumns(this);

        columns[this.live.key] = {
            ...columns[this.live.key],
            value: data => (data[this.live.key] ? 'Yes' : 'No'),
        };

        columns[this.date.key] = {
            ...columns[this.date.key],
            value: data => moment(data[this.date.key] * 1000).format(newDateAndTimeFormatWithSeconds),
        };

        return filterVisibleColumns(columns, visibleColumns);
    },
    live: {
        key: 'live',
        label: 'Live',
    },
    id: {
        key: 'ticketId',
        label: 'Bet ID',
    },
    code: {
        key: 'ticketCode',
        label: 'Ticket ID',
    },
    issuerAgent: {
        key: 'issuerAgent',
        label: 'Issuer Cashier',
    },
    date: {
        key: 'ticketIssueDate',
        label: 'Date',
    },
    type: {
        key: 'ticketType',
        label: 'Type',
    },
    market: {
        key: 'marketName',
        label: 'Market',
    },
    outcomeName: {
        key: 'outcomeName',
        label: 'Outcome Name',
    },
    odd: {
        key: 'outcomeOdd',
        label: 'Odd',
    },
    payout: {
        key: 'ticketTotalPayoutAmount',
        label: 'Payout',
    },
    stake: {
        key: 'ticketTotalStakeAmount',
        label: 'Stake',
    },
    win: {
        key: 'ticketTotalWinAmount',
        label: 'Win',
    },
    status: {
        key: 'ticketStatus',
        label: 'Status',
    },
};

export const SERVER_ERRORS_COLUMNS = {
    toExcel: function ({ visibleColumns, messageList }) {
        const { reason, ...columns } = getColumns(this);

        messageList.forEach((message, index) => {
            columns[`errorReason_${index}`] = {
                label: `Reason (${message.langCode})`,
                value: data => data.messageList[index].errorReason,
            };
        });

        return filterVisibleColumns(columns, visibleColumns);
    },
    rowNumber: {
        key: 'rowNumber',
        label: '#',
    },
    code: {
        key: 'errorCode',
        label: 'Code',
    },
    serviceName: {
        key: 'serviceName',
        label: 'Service Name',
    },
    description: {
        key: 'errorDescription',
        label: 'Description',
    },
    reasons: {
        key: 'reasons',
        label: 'Reasons',
    },
};

export const MONITORING_EVENT_LIST_COLUMNS = {
    toExcel: function ({ visibleColumns } = {}) {
        const columns = getColumns(this);

        columns[this.date.key] = {
            ...columns[this.date.key],
            value: data => moment(data[this.date.key]).format(newDateAndTimeFormat),
        };

        return filterVisibleColumns(columns, visibleColumns);
    },
    mbn: {
        key: 'mbn',
        label: 'MBN',
    },
    status: {
        key: 'statusName',
        label: 'Status',
    },
    date: {
        key: 'scheduleDate',
        label: 'Date',
    },
    home: {
        key: 'homeName',
        label: 'Home',
    },
    odd: {
        key: 'homeOdds',
        label: 'Odd',
    },
    risk: {
        key: 'homeRiskFactorValue',
        label: 'Risk',
    },
    draw: {
        key: 'drawName',
        label: 'Draw',
    },
    drawOdds: {
        key: 'drawOdds',
        label: 'Odd',
    },
    drawRiskFactorValue: {
        key: 'drawRiskFactorValue',
        label: 'Risk',
    },
    away: {
        key: 'awayName',
        label: 'Away',
    },
    awayOdds: {
        key: 'awayOdds',
        label: 'Odd',
    },
    awayRiskFactorValue: {
        key: 'awayRiskFactorValue',
        label: 'Risk',
    },
    league: {
        key: 'longEventName',
        label: 'League',
    },
    pre: {
        key: 'preMatchMarkets',
        label: 'Pre',
    },
    live: {
        key: 'liveMarkets',
        label: 'Live',
    },
};

export const ACCOUNTING_PERIOD_RECORD_COLUMNS = {
    toExcel: function ({ visibleColumns } = {}) {
        const columns = getColumns(this);

        return filterVisibleColumns(columns, visibleColumns);
    },
    period: {
        key: 'period',
        label: 'Period',
    },
    agentName: {
        key: 'agentName',
        label: 'Agent',
    },
    cashier: {
        key: 'cashier',
        label: 'Cashier',
    },
    sales: {
        key: 'sales',
        label: 'Sales',
    },
    cancels: {
        key: 'cancels',
        label: 'Cancels',
    },
    payments: {
        key: 'payments',
        label: 'Payments',
    },
    refunds: {
        key: 'refunds',
        label: 'Refunds',
    },
    refundables: {
        key: 'refundables',
        label: 'Refundables',
    },
    interims: {
        key: 'interims',
        label: 'Interims',
    },
    commissions: {
        key: 'commissions',
        label: 'Commissions',
    },
    debtOrCredit: {
        key: 'debtOrCredit',
        label: 'Debt/Credit',
    },
    extraDebtOrCredit: {
        key: 'extraDebtOrCredit',
        label: 'Extra Debt/Credit',
    },
    actualDebtOrCredit: {
        key: 'actualDebtOrCredit',
        label: 'Actual Debt/Credit',
    },
};

export const PLAYER_SEARCH_COLUMNS = {
    accountNumber: {
        key: 'accountNumber',
        label: 'Account Number',
    },
    fullName: {
        key: 'fullName',
        label: 'Full Name',
    },
    name: {
        key: 'name',
        label: 'First Name',
    },
    surname: {
        key: 'surname',
        label: 'Last Name',
    },
    status: {
        key: 'status',
        label: 'Player Status',
    },
    idDocNumber: {
        key: 'idDocNumber',
        label: 'Identity Document Number',
    },
    email: {
        key: 'email',
        label: 'Email',
    },
    phone: {
        key: 'phone',
        label: 'Phone Number',
    },
    mobile: {
        key: 'mobile',
        label: 'Mobile',
    },
    lastLoginIp: {
        key: 'lastLoginIp',
        label: 'Last Login IP',
    },
    city: {
        key: 'city',
        label: 'City',
    },
    registrationDate: {
        key: 'registrationDate',
        label: 'Registration Date',
    },
    accountLevel: {
        key: 'accountLevel',
        label: 'Account Level',
    },
    clientType: {
        key: 'clientType',
        label: 'Client Type',
    },
    address: {
        key: 'address',
        label: 'Address',
    },
    verificationStatus: {
        key: 'verificationStatus',
        label: 'Verification Status',
    },
    currency: {
        key: 'currency',
        label: 'Currency',
    },
};

export const PLAYER_ACTIVITY_REPORT_COLUMNS = {
    group: {
        key: 'group',
        label: 'Group',
    },
    customerId: {
        key: 'customerId',
        label: 'Customer ID',
    },
    realBalance: {
        key: 'realBalance',
        label: 'Real Balance',
    },
    bonusBalance: {
        key: 'bonusBalance',
        label: 'Bonus Balance',
    },
    fullName: {
        key: 'fullName',
        label: 'Name',
    },
    registrationDate: {
        key: 'registrationDate',
        label: 'Sign-up(Registration) Date',
    },
    lastLoginDate: {
        key: 'lastLoginDate',
        label: 'Last Login Date',
    },
    firstDepositDate: {
        key: 'firstDepositDate',
        label: 'First Deposit Date',
    },
    firstDepositAmount: {
        key: 'firstDepositAmount',
        label: 'First Deposit Amount',
    },
    lastDepositDate: {
        key: 'lastDepositDate',
        label: 'Last Deposit Date',
    },
    lastDepositAmount: {
        key: 'lastDepositAmount',
        label: 'Last Deposit Amount',
    },
    depositCount: {
        key: 'depositCount',
        label: 'Deposit Count',
    },
    totalBets: {
        key: 'totalBets',
        label: 'Total Bets',
    },
    totalGGR: {
        key: 'totalGGR',
        label: 'Total GGR',
    },
    totalDepositAmount: {
        key: 'totalDepositAmount',
        label: 'Total Deposit Amount',
    },
    lastWithdrawalDate: {
        key: 'lastWithdrawalDate',
        label: 'Last Withdrawal Date',
    },
    lastWithdrawalAmount: {
        key: 'lastWithdrawalAmount',
        label: 'Last Withdrawal Amount',
    },
    withdrawalCount: {
        key: 'withdrawalCount',
        label: 'Withdrawal Count',
    },
    totalWithdrawalAmount: {
        key: 'totalWithdrawalAmount',
        label: 'Total Withdrawal Amount',
    },
    // currentPendingWithdrawals: {
    //     key: 'currentPendingWithdrawals',
    //     label: 'Current Pending Withdrawals',
    // },
    declinedWithdrawals: {
        key: 'declinedWithdrawals',
        label: 'Declined Withdrawals',
    },
    bonusCount: {
        key: 'bonusCount',
        label: 'Bonus Count',
    },
    bonuses: {
        key: 'bonuses',
        label: 'Bonuses',
    },
    freeBetsGiven: {
        key: 'freeBetsGiven',
        label: 'Free Bets Given',
    },
    // chargebacks: {
    //     key: 'chargebacks',
    //     label: 'Chargebacks',
    // },
    bets: {
        key: 'bets',
        label: 'Bets',
    },
    wins: {
        key: 'wins',
        label: 'Wins',
    },
    numberOfBets: {
        key: 'numberOfBets',
        label: 'Number Of Bets',
    },
    ggr: {
        key: 'ggr',
        label: 'GGR',
    },
    ngr: {
        key: 'ngr',
        label: 'NGR',
    },
    frozen: {
        key: 'frozen',
        label: 'Frozen',
    },
    // sportsBalanceChange: { key: 'sportsBalanceChange', label: 'Sports Balance Change' },
    // balanceChange: { key: 'balanceChange', label: 'Balance Change' },
    mainWalletId: { key: 'mainWalletId', label: 'Main Wallet ID' },
};

export const DECLINED_BETS_HISTORY_COLUMNS = {
    creationTime: {
        key: 'creationTime',
        label: 'Bet Date & Time',
    },
    accountNumber: {
        key: 'accountNumber',
        label: 'Account Number',
    },
    sportsLevel: {
        key: 'sportsLevel',
        label: 'Sports Level',
    },
    sport: {
        key: 'sport',
        label: 'Sport',
    },
    league: {
        key: 'league',
        label: 'League',
    },
    event: {
        key: 'event',
        label: 'Event',
    },
    eventDate: {
        key: 'eventDate',
        label: 'Event Date',
    },
    market: {
        key: 'market',
        label: 'Market',
    },
    selections: {
        key: 'selections',
        label: 'Selections',
    },
    operator: {
        key: 'operator',
        label: 'Operator',
    },
    stake: {
        key: 'stake',
        label: 'Stake',
    },
    odds: {
        key: 'odds',
        label: 'Odds',
    },
    declineType: {
        key: 'declineType',
        label: 'Decline Type',
    },
    declineDetailType: {
        key: 'declineDetailType',
        label: 'Decline Details',
    },
};

export const USER_INTERFACE_COLUMNS = {
    key: {
        key: 'key',
        label: 'Key',
    },
    label: {
        key: 'label',
        label: 'Label',
    },
    page: {
        key: 'page',
        label: 'Page',
    },
};

export const USER_DETAILS_pAYMENTS = {
    functionality: {
        key: 'functionality',
        label: 'Functionality',
    },
    status: {
        key: 'status',
        label: 'Status',
    },
    modifiedBy: {
        key: 'modifiedBy',
        label: 'ModifiedBy',
    },
    modifiedOn: {
        key: 'modifiedOn',
        label: 'ModifiedOn',
    },
    comments: {
        key: 'comments',
        label: 'Comments',
    },
    action: {
        key: 'action',
        label: 'Action',
    },
};

export const TAX_RETURN_REPORT_TABLE_COLUMNS = {
    settlementDate: {
        key: 'settlementDate',
        label: 'Month',
    },
    returnBeforeTax: {
        key: 'returnBeforeTax',
        label: 'Return Before Taxation',
    },
    returnAfterTax: {
        key: 'returnAfterTax',
        label: 'Return After Taxation',
    },
    taxAmount: {
        key: 'taxAmount',
        label: 'Tax Amount',
    },
    taxPercentage: {
        key: 'taxPercentage',
        label: 'Tax%',
    },
};

export const TAX_RETURN_DAY_TABLE_COLUMNS = {
    accountNumber: {
        key: 'accountNumber',
        label: 'Account Number',
    },
    returnBeforeTax: {
        key: 'returnBeforeTax',
        label: ' Return Before Tax',
    },
    returnAfterTax: {
        key: 'returnAfterTax',
        label: ' Return After Tax',
    },
    taxAmount: {
        key: 'taxAmount',
        label: 'Tax Amount',
    },
    taxPercentage: {
        key: 'taxPercentage',
        label: 'Tax%',
    },
};
export const TAX_TURNOVER_REPORT_TABLE_COLUMNS = {
    settlementDate: {
        key: 'settlementDate',
        label: 'Month',
    },
    returnBeforeTax: {
        key: 'returnBeforeTax',
        label: 'Turnover Before Taxation',
    },
    returnAfterTax: {
        key: 'returnAfterTax',
        label: 'Turnover After Taxation',
    },
    taxAmount: {
        key: 'taxAmount',
        label: 'Tax Amount',
    },
    taxPercentage: {
        key: 'taxPercentage',
        label: 'Tax%',
    },
};

export const TAX_TURNOVER_DAY_TABLE_COLUMNS = {
    accountNumber: {
        key: 'accountNumber',
        label: 'Account Number',
    },
    returnBeforeTax: {
        key: 'returnBeforeTax',
        label: 'Turnover Before Taxation',
    },
    returnAfterTax: {
        key: 'returnAfterTax',
        label: 'Turnover After Taxation',
    },
    taxAmount: {
        key: 'taxAmount',
        label: 'Tax Amount',
    },
    taxPercentage: {
        key: 'taxPercentage',
        label: 'Tax%',
    },
};

export const DEPOSIT_WITHDRAWAL_COLUMNS = {
    creationDate: {
        key: 'creationDate',
        label: 'Creation Date',
    },
    lastUpdateDate: {
        key: 'lastUpdateDate',
        label: 'Last Update Date ',
    },
    transactionId: {
        key: 'transactionId',
        label: 'Transaction ID',
    },
    merchantOrderId: {
        key: 'merchantOrderId',
        label: 'Merchant Order ID',
    },
    paymentErrorMessage: {
        key: 'paymentErrorMessage',
        label: 'Payment Error Message',
    },
    paymentProvider: {
        key: 'paymentProvider',
        label: 'Payment Provider',
    },

    customerId: {
        key: 'customerId',
        label: 'Customer ID',
    },
    phone: {
        key: 'phone',
        label: 'Phone',
    },
    fullName: {
        key: 'fullName',
        label: 'Full Name',
    },
    amount: {
        key: 'amount',
        label: 'Amount',
    },
    transactionNote: {
        key: 'transactionNote',
        label: 'Transaction Note',
    },

    paymentStatus: {
        key: 'paymentStatus',
        label: 'Status',
    },

    handledBy: {
        key: 'handledBy',
        label: 'Handled By',
    },
    action: {
        key: 'action',
        label: 'Action',
    },
    approve: {
        key: 'approve',
        label: 'Approve',
    },
    declineReason: {
        key: 'declineReason',
        label: 'Decline Reason',
    },
    commentByUser: {
        key: 'commentByUser',
        label: 'Comment',
    },
    accountStatus: {
        key: 'accountStatus',
        label: 'Account Status',
    },
    verificationStatus: {
        key: 'verificationStatus',
        label: 'Verification Status',
    },
    reviewStatus: {
        key: 'reviewStatus',
        label: 'Review Status',
    },
    source: {
        key: 'source',
        label: 'Source',
    },
    rrn: {
        key: 'rrn',
        label: 'RRN',
    },
    intRef: {
        key: 'intRef',
        label: 'Int Ref',
    },
};

export const WITHDRAWAL_AUTOPROCESSING_COLUMNS = {
    name: {
        key: 'name',
        label: 'Rule Set Name',
    },
    paymentProvider: {
        key: 'paymentProvider',
        label: 'paymentProvider',
    },
    paymentMethod: {
        key: 'paymentMethod',
        label: 'paymentMethod',
    },
    status: {
        key: 'status',
        label: 'status',
    },
    actionType: {
        key: 'actionType',
        label: 'actionType',
    },
    note: {
        key: 'note',
        label: 'note',
    },
};

export const FROZEN_ACCOUNTS_REPORT_COLUMNS = {
    customerId: {
        key: 'customerId',
        label: 'Customer ID',
    },
    fullName: {
        key: 'fullName',
        label: 'Full Name',
    },
    balance: {
        key: 'balance',
        label: 'Balance',
    },
    playerCurrentStatus: { key: 'playerCurrentStatus', label: 'Player Current Status' },
    freezeType: {
        key: 'freezeType',
        label: 'Freeze Type',
    },
    freezeDate: {
        key: 'freezeDate',
        label: 'Freeze Date',
    },
    frozenBy: {
        key: 'frozenBy',
        label: 'Frozen By',
    },
    reason: {
        key: 'reason',
        label: 'Reason',
    },
};

export const REGISTRATIONS_HISTORY_DEFAULT_COLUMNS = {
    field: {
        key: 'field',
        label: 'Field',
    },
    registrationsCount: {
        key: 'registrationsCount',
        label: 'Registrations',
    },
    registrationAndDepositCount: {
        key: 'registrationAndDepositCount',
        label: 'Registered and Deposited',
    },
    firstDepositorsCount: {
        key: 'firstDepositorsCount',
        label: 'First Depositors',
    },
    conversionRatio: {
        key: 'conversionRatio',
        label: 'Conversion Ratio',
    },
    totalDepositAmount: {
        key: 'totalDepositAmount',
        label: 'Total Deposit Amount',
    },
    turnover: {
        key: 'turnover',
        label: 'Turnover',
    },
    ngr: {
        key: 'ngr',
        label: 'NGR',
    },
    bonusSpent: {
        key: 'bonusSpent',
        label: 'Bonus Spent',
    },
};

export const REGISTRATIONS_HISTORY_PLAYER_COLUMNS = {
    customerId: {
        key: 'customerId',
        label: 'Customer Id',
    },
    fullName: {
        key: 'fullName',
        label: 'Full Name',
    },

    country: {
        key: 'country',
        label: 'Country',
    },
    birthDate: {
        key: 'birthDate',
        label: 'Birth Date',
    },
    registrationDate: {
        key: 'registrationDate',
        label: 'Registration Date',
    },
    registrationIp: {
        key: 'registrationIp',
        label: 'Registration IP',
    },
    email: {
        key: 'email',
        label: 'Email',
    },
    phoneNumber: {
        key: 'phoneNumber',
        label: 'Phone Number',
    },
    operatingSystem: {
        key: 'operatingSystem',
        label: 'Operating System',
    },
    product: {
        key: 'product',
        label: 'Product',
    },
    deposited: {
        key: 'deposited',
        label: 'Deposited',
    },
    firstDepositAmount: {
        key: 'firstDepositAmount',
        label: 'First Deposit Amount',
    },
    totalDepositAmount: {
        key: 'totalDepositAmount',
        label: 'Total Deposit Amount',
    },
    turnover: {
        key: 'turnover',
        label: 'Turnover',
    },
    ngr: {
        key: 'ngr',
        label: 'NGR',
    },
    firstDepositDate: {
        key: 'firstDepositDate',
        label: 'First Deposit Date',
    },
    bonusSpent: {
        key: 'bonusSpent',
        label: 'Bonus Spent',
    },
};

export const NET_CASH_REPORT_FIRST_GROUP_COLUMNS = {
    groupField: {
        key: 'groupField',
        label: 'Group',
    },
    depositCount: {
        key: 'depositCount',
        label: '#of Deposits ',
    },
    depositAmount: {
        key: 'depositAmount',
        label: 'Deposit Amount',
    },
    averageDepositAmount: {
        key: 'averageDepositAmount',
        label: 'Average Deposit Amount',
    },
    withdrawalCount: {
        key: 'withdrawalCount',
        label: '%of Withdrawals',
    },
    withdrawalAmount: {
        key: 'withdrawalAmount',
        label: 'Withdrawals Amount',
    },

    averageWithdrawalAmount: {
        key: 'averageWithdrawalAmount',
        label: 'Average Withdrawal Amount',
    },
    netCash: {
        key: 'netCash',
        label: 'Net Cash',
    },
    netCashToDepositRatio: {
        key: 'netCashToDepositRatio',
        label: 'NetCash to Deposit Ratio',
    },
};

export const PLAYER_SEGMENTATION_COLUMNS = {
    id: {
        key: 'id',
        label: 'ID',
    },
    name: {
        key: 'name',
        label: 'Name ',
    },
    createdAt: {
        key: 'createdAt',
        label: 'Created At',
    },
    updatedAt: {
        key: 'updatedAt',
        label: 'Updated At',
    },
    createdBy: {
        key: 'createdBy',
        label: 'Created By',
    },
    isManual: {
        key: 'isManual',
        label: 'Segment type',
    },
};
export const PLAYER_SEGMENTATION_REPORT_COLUMNS = {
    id: {
        key: 'id',
        label: 'ID',
    },
    segmentName: {
        key: 'segmentName',
        label: 'Segment Name',
    },
    accountNumber: {
        key: 'accountNumber',
        label: 'Account Number',
    },
    firstName: {
        key: 'firstname',
        label: 'First Name',
    },
    lastName: {
        key: 'lastname',
        label: 'Last Name',
    },

    isManual: {
        key: 'isManual',
        label: 'Segment Type',
    },
    updatedAt: {
        key: 'updatedAt',
        label: 'Updated At',
    },
};

export const PROMOTIONS_COLUMNS = {
    id: {
        key: 'id',
        label: 'ID',
    },
    type: {
        key: 'type',
        label: 'Type',
    },
    promotionName: {
        key: 'promotionName',
        label: 'Promotion Name',
    },
    promotionId: {
        key: 'promotionId',
        label: 'Promotion ID',
    },
    operator: {
        key: 'operator',
        label: 'Operator',
    },
    csv: {
        key: 'csv',
        label: 'CSV',
    },
    trigger: {
        key: 'trigger',
        label: 'Trigger',
    },
    status: {
        key: 'status',
        label: 'Status',
    },
    startDate: {
        key: 'startDate',
        label: 'Start Date',
    },
    endDate: {
        key: 'endDate',
        label: 'End Date',
    },
    bonusName: {
        key: 'bonusName',
        label: 'Bonus Name ',
    },
    bonusCode: {
        key: 'bonusCode',
        label: 'Bonus Code',
    },
    actions: {
        key: 'actions',
        label: 'Actions',
    },
};

[
    GAMING_ACTIVITY_FIRST_GROUP_COLUMNS,
    TRANSACTION_COLUMNS,
    BETS_INFORMATION_COLUMNS,
    SERVER_ERRORS_COLUMNS,
    MONITORING_EVENT_LIST_COLUMNS,
    ACCOUNTING_PERIOD_RECORD_COLUMNS,
    PLAYER_SEARCH_COLUMNS,
    DECLINED_BETS_HISTORY_COLUMNS,
    USER_INTERFACE_COLUMNS,
    DEPOSIT_WITHDRAWAL_COLUMNS,
    WITHDRAWAL_AUTOPROCESSING_COLUMNS,
    REGISTRATIONS_HISTORY_DEFAULT_COLUMNS,
    REGISTRATIONS_HISTORY_PLAYER_COLUMNS,
    PLAYER_SEGMENTATION_COLUMNS,
].forEach(columns => {
    Object.defineProperty(columns, 'toExcel', {
        enumerable: false,
    });
});

export const INACTIVE_PLAYERS_REPORT_COLUMNS = {
    customerId: {
        key: 'customerId',
        label: 'Customer ID',
    },
    fullName: {
        key: 'fullName',
        label: 'Full Name',
    },
    brand: {
        key: 'brand',
        label: 'Brand',
    },
    inActivityDate: {
        key: 'inActivityDate',
        label: 'Inactivity Date',
    },
    lastLoginDate: {
        key: 'lastLoginDate',
        label: 'Last Login Date',
    },
    balance: {
        key: 'balance',
        label: 'Balance',
    },
    pendingBetsAmount: {
        key: 'pendingBetsAmount',
        label: 'Pending Bets Amount',
    },
    processStatus: {
        key: 'processStatus',
        label: 'Process Status',
    },
    addNote: {
        key: 'addNote',
        label: 'Add Note',
    },
};

export const PLAYER_BONUSES_REPORT_COLUMNS = {
    accountNumber: {
        key: 'accountNumber',
        label: 'Customer ID',
    },
    reason: {
        key: 'reason',
        label: 'Reason',
    },
    operator: {
        key: 'operator',
        label: 'Operator',
    },
    bonusGGR: {
        key: 'bonusGGR',
        label: 'Bonus GGR',
    },
    bonusId: {
        key: 'bonusId',
        label: 'Bonus ID',
    },
    bonusIssuingMethod: {
        key: 'bonusIssuingMethod',
        label: 'Bonus Issuing Method',
    },
    // bonusName: {
    //     key: 'bonusName',
    //     label: 'Bonus Name',
    // },
    bonusSpentAmount: {
        key: 'bonusSpentAmount',
        label: 'Bonus Spent Amount',
    },
    bonusStatus: {
        key: 'bonusStatus',
        label: 'Bonus Status',
    },
    bonusType: {
        key: 'bonusType',
        label: 'Bonus Type',
    },
    boostedBetOdd: {
        key: 'boostedBetOdd',
        label: 'Boosted Bet Odd',
    },
    cancelledBy: {
        key: 'cancelledBy',
        label: 'Cancelled By',
    },
    closureReason: {
        key: 'closureReason',
        label: 'Closure Reason',
    },
    currentBonusBalance: {
        key: 'currentBonusBalance',
        label: 'Current Bonus Balance',
    },
    // daysTillExpiration: {
    //     key: 'daysTillExpiration',
    //     label: 'Days Till Expiration',
    // },
    depositAmount: {
        key: 'depositAmount',
        label: 'Deposit/Transfer Amount',
    },
    depositTransactionId: {
        key: 'depositTransactionId',
        label: 'Deposit Transaction ID',
    },
    depositedAt: {
        key: 'depositedAt',
        label: 'Deposited At',
    },
    expiresAt: {
        key: 'expiresAt',
        label: 'Expires At',
    },
    freeBetReturns: {
        key: 'freeBetReturns',
        label: 'Free Bet Returns',
    },
    givenAmount: {
        key: 'givenAmount',
        label: 'Bonus Given  Amount',
    },
    givenAt: {
        key: 'givenAt',
        label: 'Bonus Given  Date',
    },
    hasQualifyingCondition: {
        key: 'hasQualifyingCondition',
        label: 'Has Qualifying Condition',
    },
    initQualifyingRequirement: {
        key: 'initQualifyingRequirement',
        label: 'Init Qualifying Requirement',
    },
    initWageringRequirement: {
        key: 'initWageringRequirement',
        label: 'Init Wagering Requirement',
    },
    issuedBy: {
        key: 'issuedBy',
        label: 'Issued By',
    },
    lastUpdatedAt: {
        key: 'lastUpdatedAt',
        label: 'Last Updated At',
    },
    originalBetOdd: {
        key: 'originalBetOdd',
        label: 'Original Bet Odd',
    },
    promotionId: {
        key: 'promotionId',
        label: 'Promotion ID',
    },
    promotionName: {
        key: 'promotionName',
        label: 'Promotion Name',
    },
    qualifyingBonusId: {
        key: 'qualifyingBonusId',
        label: 'Qualifying Bonus Id',
    },
    recreatedFromId: {
        key: 'recreatedFromId',
        label: 'Recreated From ID',
    },
    redeemedBonusAmount: {
        key: 'redeemedBonusAmount',
        label: 'Redeemed Bonus Amount',
    },
    scheduledCreationDate: {
        key: 'scheduledCreationDate',
        label: 'Scheduled Creation Date',
    },
    userBonusId: {
        key: 'userBonusId',
        label: 'Player Bonus ID',
    },
    wagerProgress: {
        key: 'wagerProgress',
        label: 'Wager Progress %',
    },
    qualifyLeftToWagerAmount: {
        key: 'qualifyLeftToWagerAmount',
        label: 'Qualify Left To Wager Amount',
    },
    qualifyWageredAmount: {
        key: 'qualifyWageredAmount',
        label: 'Qualify Wagered Amount',
    },
    withdrawLeftToWagerAmount: {
        key: 'withdrawLeftToWagerAmount',
        label: 'Withdraw Left To Wager Amount',
    },
    withdrawWageredAmount: {
        key: 'withdrawWageredAmount',
        label: 'Withdraw Wagered Amount',
    },
    cancelledAt: {
        key: 'cancelledAt',
        label: 'Cancelled At',
    },
};

export const MENU_MANAGEMENT_TABLE_COLUMNS = {
    id: {
        key: 'id',
        label: 'ID',
    },
    name: {
        key: 'name',
        label: 'Name',
    },
    parent: {
        key: 'parent',
        label: 'Parent Menu',
    },
    actions: {
        key: 'actions',
        label: 'Actions',
    },
};

export const BETTING_RULES_COLUMNS = {
    sportName: {
        key: 'sportName',
        label: 'sportName',
    },
    label: {
        key: 'label',
        label: 'Label',
    },
};

export const TICKET_OPERATIONS_HISTORY_COLUMNS = {
    createdAt: {
        key: 'createdAt',
        label: 'Created At',
    },
    errorCode: {
        key: 'errorCode',
        label: 'Error Code',
    },
    errorArgs: {
        key: 'errorArgs',
        label: 'Error Args',
    },
    executor: {
        key: 'executor',
        label: 'Executor',
    },
    id: {
        key: 'id',
        label: 'ID',
    },
    operationType: {
        key: 'operationType',
        label: 'Operation Type',
    },
    requestId: {
        key: 'requestId',
        label: 'Request Id',
    },
    status: {
        key: 'status',
        label: 'Status',
    },
    ticketCode: {
        key: 'ticketCode',
        label: 'Ticket Code',
    },
    ticketId: {
        key: 'ticketId',
        label: 'Ticket Id',
    },
};
